import ProfileTopNavigation from "./ProfileTopNavigation";
import DeleteAccountSection from "../../PageComponent/ProfilePage/DeleteAccountSection";
function DeleteAccount() {

  return (
    <div className="text-coalBlack">
      <ProfileTopNavigation pageTitle={"Delete account"} />
      <DeleteAccountSection />
    </div>
  );
}

export default DeleteAccount;
